{
  "id": "hekate",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Hécate",
    "en": "Hekate"
  },
  "icon": "gods/hekate",
  "portrait": "gods/hekate-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "lampades": 1
  },
  "unlocks": ["lampades", "asper-blood", "mythic-rejuvenation", "celerity"],
  "powers": ["tartarian-gate"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml MythicAgeHekate)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 lampades at the Temple (Kronos: +1 from KronosExtra*, so 2). God power TartarianGate (cooldown 240 s)."
  }
}
